import React from 'react';
import { Checkbox } from '@atlaskit/checkbox';
import { CheckboxField } from '@atlaskit/form';
import { legalLinks } from '@css-xp/ppc-consent-hub';
import './terms-and-conditions-details.scss';

export type EditSubscriptionTermsAndConditionsProps = {
  agreedToTnC?: boolean;
  isConfirmationCheckboxRequired?: boolean;
  tncTexts: React.FC<any>[];
  onChange?: () => void;
};

export const EditSubscriptionTermsAndConditions: React.FC<EditSubscriptionTermsAndConditionsProps> = ({
  agreedToTnC,
  isConfirmationCheckboxRequired = true,
  tncTexts,
  onChange,
}) => {
  return (
    <div className="subscriptions-terms-and-conditions-container mt-20 js-consent-hub-text">
      {tncTexts.map((TermsAndConditionText, index) => {
        return <TermsAndConditionText className="terms-and-conditions-text" key={`tnc-${index}`} />;
      })}

      {isConfirmationCheckboxRequired && agreedToTnC !== undefined && onChange !== undefined && (
        <div className="mt-20">
          <CheckboxField name="edit-subscription-ppc-tnc" isRequired={true}>
            {({ fieldProps }) => (
              <Checkbox
                {...fieldProps}
                label={
                  <span className="terms-and-conditions-checkbox-text" data-testid="terms-and-conditions-checkbox-text">
                    I agree to the <a href={legalLinks.termsOfUseUrl}>Atlassian Cloud Terms of Service</a> and
                    acknowledge the <a href={legalLinks.privacyPolicyUrl}>Privacy Policy.</a>
                  </span>
                }
                isChecked={agreedToTnC}
                onChange={onChange}
                testId="terms-and-conditions-checkbox"
              />
            )}
          </CheckboxField>
        </div>
      )}
    </div>
  );
};
